export enum HouseLandPermissionEnum {
    None        = 0x00,
    CanView     = 0x01 << 0,
    CanCreateSaleFromHouseAndLandSearch = 0x01 << 1,
}
